import { ISchema, PaywallComponentProps } from '../@types'
import { mergeDeep } from '@/helpers/utils'

export default (schema: ISchema): ISchema =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				scratchCardModal: true,
				initialDiscount: false,
				countdown: { autoStart: false },
			},
			order: [
				'PaywallCountdownQuickAccess',
				'PaywallHead',
				'PaywallWeightPredict',
				[
					'PaywallTitle',
					({ ctx }): PaywallComponentProps.Title => ({
						title: ctx.removeDiscount
							? `Grab your Personal Tai Chi Plan + <span class="text-success">Printable Guide</span> before it’s gone!`
							: `Grab your Personal Tai Chi Plan + Printable Guide—<span class="text-attention">NOW 75% OFF!</span>`,
						textAlignment: 'center',
						customStyles: {
							marginTop: '2rem',
						},
					}),
				],
				'PaywallCountdown',
				'PaywallPlanPicker',
				[
					'PaywallButton',
					({ $t }): PaywallComponentProps.Button => ({
						text: $t('common.controls.get_my_plan'),
						type: 'GET_MY_PLAN_PLANPICKER',
						blockViewTitle: 'ONBOARDING_PAYWALL_PRODUCT_SELECTION_1_BLOCK',
						clickEvent: 'openBillingModal',
					}),
				],
				'PaywallPrintableGuideBanner',
				'PaywallPriceDisclaimer',
				[
					'PaywallTextLine',
					({ $t }): PaywallComponentProps.TextLine => ({
						text: $t('male-tai-chi-yoga-pr.paywall.what_you_get.badge'),
						type: 'success',
						textAlignment: 'center',
						customStyles: {
							marginTop: 'var(--size-40)',
							marginBottom: 'var(--size-24)',
						},
					}),
				],
				'PaywallWhatYouGetBlock',
				'PaywallRatings',
				[
					'PaywallButton',
					({ $t }): PaywallComponentProps.Button => ({
						text: $t('common.controls.get_my_plan'),
						type: 'GET_MY_PLAN_PLANPICKER',
						blockViewTitle: 'ONBOARDING_PAYWALL_PRODUCT_SELECTION_2_BLOCK',
						clickEvent: 'openBillingModal',
					}),
				],
				'PaywallCustomerReviews',
				[
					'PaywallTitle',
					({ $t }): PaywallComponentProps.Title => ({
						title: $t('prepaywall.crm.visible_result.title'),
						customStyles: {
							marginLeft: '20px',
							marginRight: '20px',
						},
					}),
				],
				'PaywallCountdown',
				'PaywallPlanPicker',
				'PaywallUserResearchBadge',
				[
					'PaywallButton',
					({ $t }): PaywallComponentProps.Button => ({
						text: $t('common.controls.get_my_plan'),
						type: 'GET_MY_PLAN_PLANPICKER',
						blockViewTitle: 'ONBOARDING_PAYWALL_PRODUCT_SELECTION_2_BLOCK',
						clickEvent: 'openBillingModal',
					}),
				],
				'PaywallPrintableGuideBanner',
				'PaywallPriceDisclaimer',
				'PaywallFooterWithMoneyback',
				'PaywallBillingModal',
				'PaywallScratchCardModal',
			],
			components: {
				PaywallScratchCardModal: ({ $t }): PaywallComponentProps.ScratchCardModal => ({
					subtitle: $t('pages.program.scratch_card.subtitle'),
					revealedContent: {
						primary: $t('pages.program.scratch_card.revealed_content.primary', { discount: 75 }),
						secondary: 'on your Personal Plan',
					},
				}),
			},
		},
	)
